import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'remote-update-domain-access-denied',
  imports: [],
  templateUrl: './access-denied.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './access-denied.css'
})
export class AccessDenied {}
